import React from 'react';
import { useLanguage, translations } from '../contexts/language';
import { Facebook, Instagram, MessageCircle, Mail, MapPin, Phone } from 'lucide-react';

export default function Footer() {
  const { currentLang } = useLanguage();
  const t = translations[currentLang];
  const isRtl = currentLang === 'ar' || currentLang === 'ku';

  return (
    <footer id="footer" className="bg-gray-900 text-white pt-16 pb-8" dir={isRtl ? 'rtl' : 'ltr'}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img
                src={process.env.PUBLIC_URL + "/media/logo.webp"}
                alt="bobatea logo"
                className="h-24 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 leading-relaxed">
              {t.footer.aboutDesc}
            </p>
            <div className="flex gap-4 pt-2">
              <a href="https://www.instagram.com/ibubble.iq/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-orange-500 transition-all duration-300 group">
                <Instagram className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
              </a>
              <a href="https://www.facebook.com/Ibubble.IQ/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-blue-600 transition-all duration-300 group">
                <Facebook className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
              </a>
              <a href="https://wa.me/9647701542782" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-green-500 transition-all duration-300 group">
                <MessageCircle className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white border-b border-white/10 pb-2 inline-block">
              {t.footer.quickLinks}
            </h3>
            <ul className="space-y-3">
              {Object.entries(t.menu).map(([key, label]) => (
                <li key={key}>
                  <a
                    href={key === 'products' ? '#products' : key === 'about' ? '#about' : key === 'contact' ? 'https://wa.me/9647701542782' : '#'}
                    target={key === 'contact' ? '_blank' : undefined}
                    rel={key === 'contact' ? 'noopener noreferrer' : undefined}
                    className="text-gray-400 hover:text-orange-400 transition-colors flex items-center gap-2"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-orange-500/50"></span>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white border-b border-white/10 pb-2 inline-block">
              {t.footer.contact}
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-5 h-5 text-orange-500 shrink-0 mt-1" />
                <span>
                  bobatea<br />
                  Araz Jamal Abdullah<br />
                  Area 115, Shirwana<br />
                  Sulaymaniyah, Kurdistan-Iraq
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Phone className="w-5 h-5 text-orange-500 shrink-0" />
                <a href="tel:+9647701542782" className="hover:text-white transition-colors" dir="ltr">+964 770 154 2782</a>
              </li>
            </ul>
          </div>

          {/* Newsletter / Extra */}
          <div>
            <div className="bg-white/5 rounded-2xl p-6 border border-white/10">
              <h4 className="text-white font-semibold mb-2">{t.footer.ctaTitle}</h4>
              <a
                href="https://wa.me/9647701542782"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-2.5 bg-gradient-to-r from-[hsl(318.46deg_26%_39.22%)] to-[hsl(318.46deg_26%_55%)] text-white rounded-xl font-medium hover:opacity-90 hover:text-white transition-opacity shadow-lg shadow-[hsl(318.46deg_26%_39.22%)]/20 flex items-center justify-center gap-2"
              >
                <MessageCircle className="w-5 h-5" />
                <span dir="ltr">+964 770 154 2782</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} bobatea. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}
